import { DealStateEnum } from '../../gql/dealGql';
import { DaysToPaymentEnum } from '../../gql/financialInfoGql';

import { Option } from '../shared/types';

import { VscPackageTypeEnum } from './types';

export const daysToPaymentArray = [
  DaysToPaymentEnum.Thirty,
  DaysToPaymentEnum.FortyFive,
  DaysToPaymentEnum.Sixty,
  DaysToPaymentEnum.Ninety,
];

export const daysToPaymentOptions: Option[] = daysToPaymentArray.map((days) => ({
  label: days.toString(),
  value: days.toString(),
}));

export const getTermName = (months: number, miles: number) =>
  `${months / 12} years/${miles / 1000}k`;

// PEN coverage names — keep in sync with services/pen/pen.constants.ts on the API.
const VSC_COVERAGE_NAME = {
  major: 'APP Major Guard',
  value: 'APP Value Guard',
  basic: 'APP Basic Guard',
  lwUpgradeMajor: 'LW Upgrade Major Guard',
  lwUpgradeMajorEv: 'LW Upgrade Major Guard EV',
} as const;

// Mirror of the API's getAllyPackage (resolvers/salesAlgo/salesAlgo.ts) so a rate
// selected in the table records the same package type the backend would derive.
// This modal surfaces Major Guard or its LW Upgrade variant, so an unrecognized
// coverage falls back to Major (this modal's product).
export const getVscPackageType = (coverageName?: string | null): VscPackageTypeEnum => {
  switch (coverageName) {
    case VSC_COVERAGE_NAME.lwUpgradeMajor:
    case VSC_COVERAGE_NAME.lwUpgradeMajorEv:
      return VscPackageTypeEnum.LWUpgradeMajor;
    case VSC_COVERAGE_NAME.value:
      return VscPackageTypeEnum.Value;
    case VSC_COVERAGE_NAME.basic:
      return VscPackageTypeEnum.Basic;
    case VSC_COVERAGE_NAME.major:
    default:
      return VscPackageTypeEnum.Major;
  }
};

export const plateTransferArr = [
  { id: 1, name: 'false', label: 'No' },
  { id: 2, name: 'true', label: 'Yes' },
];

export const CARD_PAYMENT_AMOUNT_MIN = 1000;
export const CARD_PAYMENT_AMOUNT_MAX = 3000;

/** * @deprecated Use the CustomDateKey GraphQL enum instead.  */
export const CUSTOM_DATE_FIELDS = {
  // Processor
  customSentToAuditField: 'deal_dates.custom_dates.sent_to_audit',
  customSentToProcessorField: `deal_dates.custom_dates.${DealStateEnum.SentToProcessor}`,

  // Titling
  customSignedField: `deal_dates.custom_dates.${DealStateEnum.Signed}`,
  customTitleReceivedField: `deal_dates.custom_dates.${DealStateEnum.TitleReceived}`,
  customWetSigSentField: 'deal_dates.custom_dates.wet_sig_sent_date',
  customWetSigReceivedField: 'deal_dates.custom_dates.wet_sig_received_date',
  // `WaitingForTitle` means that the payoff has been sent because the previous state is `SendPayoff`.
  customPayoffSentField: `deal_dates.custom_dates.${DealStateEnum.WaitingForTitle}`,

  // Temp Tags
  temporary_registration_tags_sent_date:
    'deal_dates.custom_dates.temporary_registration_tags_sent_date',
  temporary_registration_tags_expiration_date:
    'deal_dates.custom_dates.temporary_registration_tags_expiration_date',
};

export type CustomDateFieldsKey = keyof typeof CUSTOM_DATE_FIELDS;
export const isCustomDateField = (fieldName: string) =>
  Object.values(CUSTOM_DATE_FIELDS).includes(fieldName);

// --- Custom Date Fields are ordered by appearance in the UI ---
export const customDateFieldsLabels: Partial<Record<CustomDateFieldsKey, string>> = {
  customSignedField: 'Signed Date',
  customPayoffSentField: 'Payoff Sent Date',
  customWetSigSentField: 'Wet Signature Sent Date',
  customWetSigReceivedField: 'Wet Signature Received Date',
  customTitleReceivedField: 'Title Received Date',
};

export const processorSectionCustomDateFields: Partial<Record<CustomDateFieldsKey, string>> = {
  customSentToAuditField: 'Sent to Audit Date',
  customSentToProcessorField: 'Sent to Processor Date',
};
